import { useState } from "react";
import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";
import { danmakuFeatures, danmakuSamples } from "@/mocks/home";

export default function Danmaku() {
  const [on, setOn] = useState(true);

  return (
    <section id="danmaku" className="scroll-mt-section bg-background-100 py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <Reveal>
          <SectionHeading
            eyebrow="弹幕"
            title="可开可关的实时弹幕"
            subtitle="弹幕是很多人看片时的陪伴感来源，但也会带来干扰。茶杯狐影视把开关放在最显眼的位置，同时保留样式调节与关键词过滤。"
          />
        </Reveal>

        <div className="mt-10 grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-start">
          <Reveal>
            <div className="rounded-lg overflow-hidden border border-background-200 bg-background-50">
              <div className="relative w-full aspect-video bg-foreground-950">
                <img
                  src="https://readdy.ai/api/search-image?query=Abstract%20cinematic%20video%20frame%20with%20warm%20amber%20and%20rust%20gradient%20light%2C%20soft%20bokeh%20highlights%2C%20moody%20dark%20atmosphere%2C%20artistic%20non%20realistic%20scene%2C%20film%20grain%20texture%2C%20clean%20composition&width=1200&height=675&seq=danmaku-player-01&orientation=landscape"
                  alt=""
                  className="w-full h-full object-cover object-top opacity-80"
                />

                <div
                  className={`absolute inset-0 p-3 md:p-5 transition-opacity duration-300 ${
                    on ? "opacity-100" : "opacity-0"
                  }`}
                  aria-hidden={!on}
                >
                  <div className="space-y-2 md:space-y-3">
                    {danmakuSamples.map((sample, index) => (
                      <p
                        key={sample.time}
                        className={`inline-block rounded-full bg-foreground-950/45 px-3 py-1 text-xs md:text-sm text-background-50 ${
                          index % 2 === 0 ? "ml-0" : "ml-8 md:ml-16"
                        }`}
                      >
                        {sample.text}
                      </p>
                    ))}
                  </div>
                </div>

                <div className="absolute inset-x-0 bottom-0 flex items-center justify-between gap-3 bg-foreground-950/70 px-3 md:px-4 py-2.5">
                  <button
                    type="button"
                    onClick={() => setOn((v) => !v)}
                    aria-pressed={on}
                    className="inline-flex items-center gap-2 rounded-md border border-background-50/30 px-3 py-1.5 text-xs md:text-sm text-background-50 whitespace-nowrap transition-colors hover:bg-background-50/15"
                  >
                    <i className={on ? "ri-chat-smile-2-fill" : "ri-chat-off-line"} />
                    {on ? "弹幕已开启" : "弹幕已关闭"}
                  </button>
                  <span className="text-xs text-background-300 whitespace-nowrap">
                    {on ? "点击左侧按钮可关闭" : "点击左侧按钮可开启"}
                  </span>
                </div>
              </div>

              <div className="px-4 py-3 text-xs md:text-sm text-foreground-500">
                示意图：弹幕开关与显示效果，实际以客户端为准。
              </div>
            </div>
          </Reveal>

          <Reveal delay={120}>
            <div className="grid gap-4">
              {danmakuFeatures.map((feature) => (
                <article
                  key={feature.title}
                  className="flex gap-4 rounded-lg bg-background-50 border border-background-200 p-4 md:p-5"
                >
                  <span className="w-11 h-11 shrink-0 rounded-lg bg-accent-100 text-accent-700 flex items-center justify-center text-xl">
                    <i className={feature.icon} />
                  </span>
                  <div>
                    <h3 className="font-heading text-base font-bold text-foreground-900">
                      {feature.title}
                    </h3>
                    <p className="mt-1.5 text-sm text-foreground-600 leading-relaxed">
                      {feature.desc}
                    </p>
                  </div>
                </article>
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}